import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ClientCard.css";
import PersonIcon from "@mui/icons-material/Person";

export default function ClientCard({
  img,
  name,
  paid,
  physicalSessions,
  voiceSessions,
  videoSessions,
  uid,
}) {
  const [isClientPhotoLoad, setIsClientPhotoLoad] = useState(false);
  return (
    <Link to={`/profile/${uid}`} className="client-card">
      {img && isClientPhotoLoad ? (
        <img
          className="icon"
          alt="client"
          src={img}
          onLoad={() => setIsClientPhotoLoad(true)}
        />
      ) : (
        <div className="icon">
          <PersonIcon />
        </div>
      )}
      <p className="name">{name}</p>
      <p className="paid">KES: {paid}</p>
      <p className="video sessions">{videoSessions} video sessions</p>
      <p className="voice sessions">{voiceSessions} voice sessions</p>
      <p className="physical sessions">{physicalSessions} physical sessions</p>
    </Link>
  );
}
